function get_recaptcha_token(siteKey, action)
{
    return new Promise((resolve, reject) => {
        grecaptcha.enterprise.ready(async () => {
            try {
                var token = await grecaptcha.enterprise.execute(siteKey, { action: action });
                resolve(token);
            } catch (error) {
                reject(error);
            }
        });
    });
}